import { Box, SimpleGrid } from '@chakra-ui/react';

import MiniStatistics from 'components/card/MiniStatistics';
import IconBox from 'components/icons/IconBox';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LuActivity } from 'react-icons/lu';
import { FaBirthdayCake, FaHome } from 'react-icons/fa';
import { FaUser } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { masterDashboard } from '../../../redux/actions/Admin.action';
import TotalLeadsChart from 'components/charts/TotalLeadsChart';
import Dialpad from './Dialpad';

export default function UserReports() {
  const counts = useSelector((state) => state.admin);
  const CountData = counts?.masterCount?.data;
  const dispatch = useDispatch();
  const getFile = useSelector((state) => state.files);
  const totalLeads = getFile?.getAllLead?.data?.totalCount || 0;

  useEffect(() => {
    dispatch(masterDashboard());
  }, []);

  return (
    <>
      <div className="mt-[100px]"></div>
      {/* Top row: Stats on left, Dialpad on right */}
      <div className="flex gap-8 items-stretch">
        {/* Stats Grid - takes remaining space */}
        <Box pt={{ base: '20px', md: '40px', xl: '50px' }} flex="1">
          <SimpleGrid
            columns={{ base: 1, md: 2, lg: 2, '2xl': 4 }}
            gap="14px"
            mb="10px"
            height="100%"
          >
            <Link to={'/master/lead'}>
              <MiniStatistics
                bgColor="#FFE4C4"
                startContent={
                  <IconBox
                    w="56px"
                    h="56px"
                    className="text-theme-dark bg-[#E6EFF7]"
                    icon={<LuActivity className="text-[24px]" />}
                  />
                }
                name="Total Lead"
                value={CountData?.leadsCount || 0}
              />
            </Link>
            <Link to={'/master/branch'}>
              <MiniStatistics
                bgColor="#E0FFFF"
                startContent={
                  <IconBox
                    w="56px"
                    h="56px"
                    className="text-theme-dark bg-[#E6EFF7]"
                    icon={<FaHome className="text-[24px]" />}
                  />
                }
                name="Total Branch"
                value={CountData?.branchCount || 0}
              />
            </Link>
            <Link to={'/master/adminUser'}>
              <MiniStatistics
                bgColor="#C6F6D5"
                startContent={
                  <IconBox
                    w="56px"
                    h="56px"
                    className="text-theme-dark bg-[#E6EFF7]"
                    icon={<FaUser className="text-[24px]" />}
                  />
                }
                name="Total Counsellor"
                value={CountData?.doctorCount || 0}
              />
            </Link>
            <Link to={'/master/birthdays'}>
              <MiniStatistics
                bgColor="#EDE9FE"
                startContent={
                  <IconBox
                    w="56px"
                    h="56px"
                    className="text-theme-dark bg-[#E6EFF7]"
                    icon={<FaBirthdayCake className="text-[24px]" />}
                  />
                }
                name="Today's Birthdays"
                value={CountData?.todayBirthdayCount || 0}
              />
            </Link>
          </SimpleGrid>
        </Box>
        {/* Dialpad - fixed width on the right, matches Bliss layout */}
        {localStorage.getItem('isIvr') === 'true' && (
          <Box
            pt={{ base: '20px', md: '40px', xl: '50px' }}
            minW="320px"
            maxW="340px"
            display="flex"
            flexDirection="column"
          >
            <Box flex="1" display="flex" flexDirection="column">
              <Dialpad />
            </Box>
          </Box>
        )}
      </div>
      <Box>
        <TotalLeadsChart />
      </Box>
    </>
  );
}
